/**
 * Server-Sent Events over fetch (EventSource cannot send Authorization headers).
 * Yields parsed `data:` JSON payloads until the stream ends or the signal aborts.
 */
export async function* streamSse(url, options) {
    const doFetch = options.fetch ?? fetch;
    const token = await options.getAccessToken();
    const response = await doFetch(url, {
        headers: {
            Accept: 'text/event-stream',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        credentials: 'include',
        signal: options.signal,
    });
    if (!response.ok || !response.body)
        throw new Error(`SSE connection failed with status ${response.status}`);
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    try {
        while (true) {
            const { value, done } = await reader.read();
            if (done)
                break;
            buffer += decoder.decode(value, { stream: true });
            let idx;
            while ((idx = buffer.indexOf('\n\n')) >= 0) {
                const chunk = buffer.slice(0, idx);
                buffer = buffer.slice(idx + 2);
                const data = chunk
                    .split('\n')
                    .filter((line) => line.startsWith('data:'))
                    .map((line) => line.slice(5).trimStart())
                    .join('\n');
                if (!data)
                    continue;
                try {
                    yield JSON.parse(data);
                }
                catch {
                    // ignore malformed frames (comments, keep-alives)
                }
            }
        }
    }
    finally {
        reader.releaseLock();
    }
}
//# sourceMappingURL=sse.js.map